__webpack_public_path__ = '/';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import SubscriberApp from './SubscriberApp';
import store from './store/index';
import './scss/style.scss';
import {initAmplify} from "../shared/services/aws";

initAmplify({
  Auth: {
    identityPoolId: process.env.COGNITO_IDENTITY_POOL_ID,
    region: process.env.AWS_REGION,
    userPoolId: process.env.COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.COGNITO_USER_POOL_WEB_CLIENT_ID,
    mandatorySignIn: false,
  },
  Storage: {
    bucket: process.env.S3_BUCKET,
    region: process.env.AWS_REGION,
  },
}).then(() => {
  ReactDOM.render(
    <Provider store={store}>
      <SubscriberApp />
    </Provider>,
    document.getElementById('subscriber-app'),
  );
})

// registerServiceWorker();
